export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="mb-4">
            <img src="/logo-white.png" alt="Tennessee Web & Design" className="h-12 w-auto" />
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
            {'"I am the light of the world. Whoever follows me will never walk in darkness."'}
            <span className="block mt-1 text-amber-500 font-medium">— John 8:12</span>
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Services</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Church Website Design</li>
            <li>GitHub Static Hosting</li>
            <li>Azure Infrastructure</li>
            <li>Ministry Branding</li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Get In Touch</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>jason.ferguson@tnwebdesign.org</li>
            <li>Serving Tennessee & Beyond</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} TN Web Design · Built to bring His light to the world.
      </div>
    </footer>
  );
}
